<template>

  <div class="feedItem panel bg-lightest black">
    <div class="w-100 font-weight-600"><span class="ml-1">Daily Sales</span></div>
    <div class="px-0 py-5 w-100">
      <div class="w-100 pt-4">
        <sales-daily :height="150" :chartData="stackBarsData"></sales-daily>
      </div>
    </div>
  </div>

</template>

<script>
  import extendedVSelect from '@/extends/vue-select'
  import SalesDaily from '../../tools/charts/SalesDaily.js'

  export default {
    data: function() {
      return{
          stackBarsData: {
              labels: ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00'],
              datasets: [{
                  label: 'Direct Sales',
                  backgroundColor: 'transparent',
                  borderColor: '#6ac951',
                  data: [15, 20, 32, 58, 79, 81]
              },
              {
                label: 'Agents',
                backgroundColor: 'transparent',
                borderColor: '#00bef0',
                data: [0, 0, 12, 48, 51, 66]
              },
              {
                label: 'Online channels',
                backgroundColor: 'transparent',
                borderColor: '#e73f47',
                data: [40, 48, 78, 88, 95, 100]
              }
            ],
          },

        }
    },
    props: {
      cardInfo: {
        type: Object
      }
    },
    components: {
        vSelect: extendedVSelect,
        SalesDaily
    }
  }
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';


  .panel{
    height: auto !important;
  }

  .ticketGraph{
    width: 59px;
    height: 110px;

  }

</style>



// WEBPACK FOOTER //
// FeedcardSalesdaily.vue?91532600